/**
 * ============================================================================
 * TAG ENGINE FINAL LOCK - Frontend Module
 * ============================================================================
 * 
 * RÈGLES STRICTES (NON NÉGOCIABLES):
 * 
 * 1. SYSTEM_TAGS_AUTO: Calculés UNIQUEMENT par le backend State Engine
 *    - nouveaute, precommande, promo, selection, offre
 *    - JAMAIS modifiés manuellement
 *    - NOTE: "date_sortie_inconnue" SUPPRIMÉ - Géré par DateAvailabilityBadge dans ProductCard
 * 
 * 2. MANUAL_TAGS: Éditables UNIQUEMENT par Admin
 *    - top_vente, incontournable, coup_de_coeur, exclusif_plateforme, quantites_limitees
 *    - JAMAIS recalculés automatiquement
 *    - Si supprimés par Admin → restent supprimés
 * 
 * 3. UI UNIFIÉE: ProductCard et ProductDetail utilisent EXACTEMENT la même logique
 * 
 * 4. DATE DE DISPONIBILITÉ: Source unique UI = DateAvailabilityBadge (ProductCard.js)
 */

// =============================================================================
// CONFIGURATION TAGS
// =============================================================================

/**
 * SYSTEM TAGS AUTO - Calculés par le State Engine backend
 * Ces tags sont READ-ONLY côté frontend
 * NOTE: date_sortie_inconnue SUPPRIMÉ - Géré par DateAvailabilityBadge dans ProductCard uniquement
 */
export const SYSTEM_TAGS_AUTO = [
  'nouveaute',
  'precommande',
  'promo',
  'selection',
  'offre'
];

/**
 * MANUAL TAGS - Éditables par Admin uniquement
 * Le State Engine NE TOUCHE JAMAIS à ces tags
 */
export const MANUAL_TAGS = [
  'top_vente',
  'incontournable',
  'coup_de_coeur',
  'exclusif_plateforme',
  'quantites_limitees',
  // Legacy (rétrocompatibilité)
  'bestseller',
  'exclusif',
  'limité'
];

// =============================================================================
// TAG LABELS - Business labels pour UI
// =============================================================================

export const TAG_LABELS = {
  // SYSTEM TAGS AUTO
  nouveaute: "Nouveauté",
  precommande: "Précommande",
  promo: "Promotion",
  selection: "Sélection du Mois",
  offre: "Offre Ponctuelle",
  // NOTE: date_sortie_inconnue SUPPRIMÉ - Géré par DateAvailabilityBadge dans ProductCard

  // MANUAL TAGS
  top_vente: "Top Vente du Moment",
  incontournable: "Incontournable",
  coup_de_coeur: "Coup de Coeur",
  exclusif_plateforme: "Exclusif Plateforme",
  quantites_limitees: "Quantités Limitées",

  // LEGACY MAPPINGS (rétrocompatibilité)
  bestseller: "Top Vente",
  exclusif: "Exclusif Plateforme",
  limité: "Quantités Limitées",
  
  // Legacy system tags (ancien format)
  offre_ponctuelle: "Offre Ponctuelle",
  selection_mois: "Sélection du Mois",
  remise: "Remise"
};

// =============================================================================
// TAG STYLES - Couleurs par tag
// =============================================================================

export const TAG_STYLES = {
  // SYSTEM TAGS AUTO - Styles IDENTIQUES pour card et detail
  nouveaute: {
    bg: "bg-green-100",
    text: "text-green-800",
    border: "border-green-300",
    cardBg: "bg-green-100",
    cardText: "text-green-800",
    cardBorder: "border-green-300"
  },
  precommande: {
    bg: "bg-blue-100",
    text: "text-blue-800",
    border: "border-blue-300",
    cardBg: "bg-blue-100",
    cardText: "text-blue-800",
    cardBorder: "border-blue-300"
  },
  promo: {
    bg: "bg-red-100",
    text: "text-red-800",
    border: "border-red-300",
    cardBg: "bg-red-100",
    cardText: "text-red-800",
    cardBorder: "border-red-300"
  },
  selection: {
    bg: "bg-purple-100",
    text: "text-purple-800",
    border: "border-purple-300",
    cardBg: "bg-purple-100",
    cardText: "text-purple-800",
    cardBorder: "border-purple-300"
  },
  offre: {
    bg: "bg-orange-100",
    text: "text-orange-800",
    border: "border-orange-300",
    cardBg: "bg-orange-100",
    cardText: "text-orange-800",
    cardBorder: "border-orange-300"
  },
  // NOTE: date_sortie_inconnue STYLE SUPPRIMÉ - Géré par DateAvailabilityBadge

  // MANUAL TAGS - Styles IDENTIQUES pour card et detail
  top_vente: {
    bg: "bg-yellow-100",
    text: "text-yellow-800",
    border: "border-yellow-300",
    cardBg: "bg-yellow-100",
    cardText: "text-yellow-800",
    cardBorder: "border-yellow-300"
  },
  incontournable: {
    bg: "bg-indigo-100",
    text: "text-indigo-800",
    border: "border-indigo-300",
    cardBg: "bg-indigo-100",
    cardText: "text-indigo-800",
    cardBorder: "border-indigo-300"
  },
  coup_de_coeur: {
    bg: "bg-pink-100",
    text: "text-pink-800",
    border: "border-pink-300",
    cardBg: "bg-pink-100",
    cardText: "text-pink-800",
    cardBorder: "border-pink-300"
  },
  exclusif_plateforme: {
    bg: "bg-cyan-100",
    text: "text-cyan-800",
    border: "border-cyan-300",
    cardBg: "bg-cyan-100",
    cardText: "text-cyan-800",
    cardBorder: "border-cyan-300"
  },
  quantites_limitees: {
    bg: "bg-amber-100",
    text: "text-amber-800",
    border: "border-amber-300",
    cardBg: "bg-amber-100",
    cardText: "text-amber-800",
    cardBorder: "border-amber-300"
  },

  // LEGACY - Styles IDENTIQUES pour card et detail
  bestseller: {
    bg: "bg-yellow-100",
    text: "text-yellow-800",
    border: "border-yellow-300",
    cardBg: "bg-yellow-100",
    cardText: "text-yellow-800",
    cardBorder: "border-yellow-300"
  },
  exclusif: {
    bg: "bg-cyan-100",
    text: "text-cyan-800",
    border: "border-cyan-300",
    cardBg: "bg-cyan-100",
    cardText: "text-cyan-800",
    cardBorder: "border-cyan-300"
  },
  limité: {
    bg: "bg-amber-100",
    text: "text-amber-800",
    border: "border-amber-300",
    cardBg: "bg-amber-100",
    cardText: "text-amber-800",
    cardBorder: "border-amber-300"
  },
  offre_ponctuelle: {
    bg: "bg-orange-100",
    text: "text-orange-800",
    border: "border-orange-300",
    cardBg: "bg-orange-100",
    cardText: "text-orange-800",
    cardBorder: "border-orange-300"
  },
  selection_mois: {
    bg: "bg-purple-100",
    text: "text-purple-800",
    border: "border-purple-300",
    cardBg: "bg-purple-100",
    cardText: "text-purple-800",
    cardBorder: "border-purple-300"
  }
};

// Default style - IDENTIQUE pour card et detail
const DEFAULT_STYLE = {
  bg: "bg-gray-100",
  text: "text-gray-800",
  border: "border-gray-300",
  cardBg: "bg-gray-100",
  cardText: "text-gray-800",
  cardBorder: "border-gray-300"
};

// =============================================================================
// UTILITY FUNCTIONS
// =============================================================================

/**
 * FONCTION PRINCIPALE - Récupère tous les tags normalisés d'un produit
 * 
 * RÈGLE: ProductCard et ProductDetail DOIVENT utiliser cette fonction
 * pour garantir une UI 100% unifiée
 * 
 * @param {Object} product - Produit avec tags, system_tags_auto, manual_tags
 * @returns {string[]} Array de tags pour affichage
 */
export function getNormalizedTags(product) {
  if (!product) return [];

  // Nouvelle structure canonique (system_tags_auto + manual_tags)
  const systemTags = product.system_tags_auto || [];
  const manualTags = product.manual_tags || [];
  
  // Si nouvelle structure existe, l'utiliser
  if (systemTags.length > 0 || manualTags.length > 0) {
    const allTags = new Set([...systemTags, ...manualTags]);
    return Array.from(allTags);
  }

  // Fallback: ancien format (tags = array)
  const tags = product.tags;
  
  if (Array.isArray(tags)) {
    return tags.filter(t => t && typeof t === "string");
  }
  
  if (typeof tags === "string" && tags.trim()) {
    return tags.split(",").map(t => t.trim()).filter(Boolean);
  }
  
  return [];
}

/**
 * Récupère le label business d'un tag
 * @param {string} tag - Tag key
 * @returns {string} Label pour UI
 */
export function getTagLabel(tag) {
  if (!tag) return "";
  return TAG_LABELS[tag] || tag.replace(/_/g, " ").replace(/\b\w/g, l => l.toUpperCase());
}

/**
 * Récupère le style CSS pour variant "detail"
 * @param {string} tag - Tag key
 * @returns {string} CSS classes
 */
export function getTagStyleDetail(tag) {
  const style = TAG_STYLES[tag] || DEFAULT_STYLE;
  return `${style.bg} ${style.text} ${style.border}`;
}

/**
 * Récupère le style CSS pour variant "card"
 * @param {string} tag - Tag key
 * @returns {string} CSS classes
 */
export function getTagStyleCard(tag) {
  const style = TAG_STYLES[tag] || DEFAULT_STYLE;
  return `${style.cardBg} ${style.cardText} ${style.cardBorder}`;
}

/**
 * Récupère l'objet style complet d'un tag
 * @param {string} tag - Tag key
 * @returns {Object} Style object
 */
export function getTagStyleObject(tag) {
  return TAG_STYLES[tag] || DEFAULT_STYLE;
}

/**
 * Vérifie si un tag est un tag système auto
 * @param {string} tag - Tag key
 * @returns {boolean}
 */
export function isSystemTag(tag) {
  return SYSTEM_TAGS_AUTO.includes(tag);
}

/**
 * Vérifie si un tag est un tag manuel
 * @param {string} tag - Tag key
 * @returns {boolean}
 */
export function isManualTag(tag) {
  return MANUAL_TAGS.includes(tag);
}

/**
 * Sépare les tags en AUTO et MANUAL
 * @param {string[]} tags - Array de tags
 * @returns {Object} { systemTags: [], manualTags: [] }
 */
export function separateTags(tags) {
  if (!Array.isArray(tags)) return { systemTags: [], manualTags: [] };
  
  return {
    systemTags: tags.filter(isSystemTag),
    manualTags: tags.filter(isManualTag)
  };
}

// =============================================================================
// EXPORTS
// =============================================================================

export default {
  SYSTEM_TAGS_AUTO,
  MANUAL_TAGS,
  TAG_LABELS,
  TAG_STYLES,
  getNormalizedTags,
  getTagLabel,
  getTagStyleDetail,
  getTagStyleCard,
  getTagStyleObject,
  isSystemTag,
  isManualTag,
  separateTags
};
